export default "__VITE_ASSET__5666109e__"